import React, { useState , useContext} from "react";
import axios from "axios";
import {useNavigate} from "react-router-dom";
import { AuthContext } from "./AuthContext";

import { sendLoginOtp, verifyLoginOtp } from "./authApi";


function LoginPage() {

const { login } = useContext(AuthContext);


  const navigate = useNavigate();
  const [mobile, setMobile] = useState("");
  const [activeOtp, setActiveOTP] = useState(false);
  const [errorSMS , setErrorSMS]  = useState(null);

  const [loading , setLoading] = useState(false);

  const [otp, setOtp] = useState("");

  const handleSendOtp = async () => {
    if (mobile.length !== 10) {
      alert("Please enter valid mobile number");
      return;
    }

    try {
      setLoading(true)
      const res = await sendLoginOtp(mobile);
      // console.log("Responsse console", res);
      if (res.data.success) {
        // console.log(res.data.message);
        setActiveOTP(true);
      }
    } catch (err) {
      setErrorSMS(err.response?.data?.message || "Something went wrong");
    }
    setLoading(false);
  };





const handleVerifyOtp = async () => {
  try {
    const res = await verifyLoginOtp(mobile, otp);

    if (!res.data?.accessToken) {
      console.error("Token missing in response", res.data);
      setErrorSMS("Login failed. Please try again.");
      return;
    }

  
    login(res.data.accessToken, res.data.user);

    navigate("/", { replace: true });

  } catch (error) {
    setErrorSMS(error.response?.data?.message || "OTP verification failed");
  }
};






  return (

    <div className="login-home-page-bg">
     <div className="login-home-page-main">
    {activeOtp === false ? (    
        <div className="login-home-page-main-row">
      
              <div className="login-home-page-left-cols">
                <p>Get ready to explore great deals</p>
                <p>Enter your mobile number to continue shopping</p>
              </div>

              <div className="login-home-page-right-cols">
                <label className="login-label">Mobile Number</label>

                <div className="login-input-box">
                  <span className="country-code">+91</span>
                  <input
                    type="tel"
                    maxLength="10"
                    placeholder="Enter your number"
                    value={mobile}
                    onChange={(e) =>
                      setMobile(e.target.value.replace(/\D/g, ""))
                    }
                  />
                </div>


                {errorSMS && (
                <p className="error-text">
                  {errorSMS}
                </p>
              )}


                          {loading ?

                            <button className="login-btn">
                                            Loading...
                              </button>
                            :
                              <button className="login-btn" onClick={handleSendOtp}>
                                            Continue
                              </button>

                          }
              

                <p className="login-terms">
                  By continuing, you agree to our Terms & Privacy Policy
                </p>
              </div>
           </div>
          ) : (

          <div className="verify-otp-home-page-left-row">


        <h2>Verify OTP</h2>
        <p>We’ve sent a 6-digit code to your mobile number</p>

        <input
          type="text"
          maxLength="6"
          placeholder="Enter 6-digit OTP"
              value={otp}
                    onChange={(e) =>
                      setOtp(e.target.value.replace(/\D/g, ""))
                    }
        />

          {errorSMS && (
                <p className="error-text">
                  {errorSMS}
                </p>
              )}

           <button onClick={handleVerifyOtp}>Verify & Continue</button>
      </div>
          )}
      
      </div>
    </div>
  );
}

export default LoginPage;
